module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.number
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47af3997"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/point/index.vue
// module id = 172
// module chunks = 1